import React, { useEffect, useState } from "react";
import withAppState from '../mobx/withAppState';
import { Steps } from '../lib/constants';
import dataLayer from '../lib/dataLayer';
import deliveryMan from '../assets/img/deliveryMan.svg';

const {dataLayerAttribute} = dataLayer; 
const {addToDataLayerList} = dataLayer;

const MenuFooterLinks = props => {

    const { activeStep, restaurant, restaurantUrl } = props;
    const [footerMenuData, setFooterMenuData] = useState([]);

    useEffect(() => {
        let isMounted = true;
        async function fetchAPI() {
            try {
                const response = await fetch(`api/Menu/FooterMenu`);
                if (response.status === 200 && isMounted) {
                    const data = await response.json();
                    if (isMounted) {
                        setFooterMenuData(data);
                    }
                }
            } catch (error) {
                // Handle error if needed
            }
        }

        fetchAPI();
    }, []);  

    let bookATableUrl = '';
    let menuType = null;

    if (footerMenuData?.bookings?.find(md => md.name === "Book A Table")) {
        bookATableUrl = footerMenuData.bookings.filter(md => md.name === "Book A Table")[0].url;
    }
    if (!!restaurant?.restaurantUrlName && activeStep === Steps.PRE_ORDER) { //at the point when the user chooses or changes the restaurant
        bookATableUrl = bookATableUrl + `${restaurant.restaurantUrlName}/book/book-a-table`;
        menuType = "local menu";
    }
    else if (!!restaurantUrl) { //at the point when the digital menu loads from a local restaurant page in the milano main site
        bookATableUrl = bookATableUrl + `${restaurant.restaurantUrlName}/book/book-a-table`;
        menuType = "local menu";
    }
    else { //at the point when the global menu loads.
        bookATableUrl = bookATableUrl + "/book/book-a-table-uk";
        menuType = "global menu";
    }

    const handleBookClick = (e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_footer" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_footer" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
            );
        }
    
        addToDataLayerList(dataLayerArray);
    }
    
    const handleOrderClick =(e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType }
            );
        }
    
    addToDataLayerList(dataLayerArray);
    }
    
    const handleDeliveryClick = (e) => {
    
        var dataLayerArray = [];
    
        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_footer" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
            );
        }
    
        addToDataLayerList(dataLayerArray);
    }

    return (
        <div>
            <div className="section-padding-xtrathin">
                <ul className="social-links">
                    <li>
                        <a href="https://twitter.com/milano_ireland" className="social-link" aria-label="X" target="_blank" rel="noopener noreferrer">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18.244 13.525 26.552 4h-1.968l-7.196 8.36L11.52 4H4.8l8.72 12.688L4.8 28h1.968l7.624-8.856L20.48 28h6.72L18.244 13.525zm-2.7 3.136-.884-1.264L7.44 5.44h3.024l5.676 8.12.884 1.264 7.376 10.552H21.4l-5.856-8.376z" fill="currentColor"></path></svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/MilanoIreland" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17.333 18.667H20l1.333-5.334h-4V10.667c0-1.373 0-2.667 2.667-2.667H21.333V3.893A35.404 35.404 0 0 0 17.893 3.667C14.12 3.667 11.333 5.973 11.333 10.267v3.066H8v5.334h3.333V28h6V18.667z" fill="currentColor"></path></svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/milanoireland/" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 3.667c-3.352 0-3.772.014-5.09.074-1.316.06-2.213.269-2.999.573a6.057 6.057 0 0 0-2.19 1.427 6.057 6.057 0 0 0-1.427 2.19c-.304.786-.513 1.683-.573 2.999C3.68 12.228 3.667 12.648 3.667 16s.014 3.772.074 5.09c.06 1.316.269 2.213.573 2.999a6.058 6.058 0 0 0 1.427 2.19 6.057 6.057 0 0 0 2.19 1.427c.786.304 1.683.513 2.999.573 1.318.06 1.738.074 5.09.074s3.772-.014 5.09-.074c1.316-.06 2.213-.269 2.999-.573a6.058 6.058 0 0 0 2.19-1.427 6.058 6.058 0 0 0 1.427-2.19c.304-.786.513-1.683.573-2.999.06-1.318.074-1.738.074-5.09s-.014-3.772-.074-5.09c-.06-1.316-.269-2.213-.573-2.999a6.057 6.057 0 0 0-1.427-2.19 6.057 6.057 0 0 0-2.19-1.427c-.786-.304-1.683-.513-2.999-.573-1.318-.06-1.738-.074-5.09-.074zm0 2.225c3.295 0 3.685.013 4.988.072 1.203.055 1.857.256 2.292.425.576.224.987.491 1.419.923.432.432.7.843.923 1.419.17.435.37 1.09.425 2.292.059 1.303.072 1.693.072 4.988s-.013 3.685-.072 4.988c-.055 1.203-.256 1.857-.425 2.292a3.826 3.826 0 0 1-.923 1.419 3.826 3.826 0 0 1-1.419.923c-.435.17-1.09.37-2.292.425-1.302.059-1.692.072-4.988.072s-3.686-.013-4.988-.072c-1.203-.055-1.857-.256-2.292-.425a3.826 3.826 0 0 1-1.419-.923 3.826 3.826 0 0 1-.923-1.419c-.17-.435-.37-1.09-.425-2.292C5.892 19.685 5.879 19.295 5.879 16s.013-3.685.072-4.988c.055-1.203.256-1.857.425-2.292.224-.576.491-.987.923-1.419a3.826 3.826 0 0 1 1.419-.923c.435-.17 1.09-.37 2.292-.425C12.315 5.892 12.705 5.879 16 5.879zm0 3.787a6.334 6.334 0 1 0 0 12.668 6.334 6.334 0 0 0 0-12.668zm0 10.443a4.11 4.11 0 1 1 0-8.219 4.11 4.11 0 0 1 0 8.22zm8.07-10.7a1.48 1.48 0 1 1-2.96 0 1.48 1.48 0 0 1 2.96 0z" fill="currentColor"></path></svg>
                        </a>
                    </li>
                </ul>
            </div>
            <div className="is-col section-padding-thin no-padding-top">
                <hr></hr>
            </div>
            <div className="menu-footer-section">
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <p className="is-title">Food</p>
                    {footerMenuData?.food?.map((item, idx) => 
                        <a key={'Food-' + idx} href={item.name === "Our Menu" ? window.location.href : item.url}
                            className="is-row"
                            title={item.name}
                            onClick={item.name === "Collection" ? handleOrderClick : item.name === "Delivery" ? handleDeliveryClick : ""}
                            target={item.name === "Cook at Home" || item.name === "Allergens & Nutritionals" ? "_blank" : "_self"}
                        >{item.name}</a>
                    )}
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <p className="is-title">Bookings</p>
                    {footerMenuData?.bookings?.map((item, idx) =>
                        <a key={'Bookings-' + idx} href={item.name === "Book A Table" ? bookATableUrl : item.url} onClick={item.name === "Book A Table" ? handleBookClick : ""} className="is-row">{item.name}</a>
                    )}
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <p className="is-title">Explore</p>
                    {footerMenuData?.explore?.map((item, idx) =>
                        <a key={'Explore-' + idx} href={item.url} className="is-row" title={item.name}>{item.name}</a>
                    )}   
                </div>
                <div className="is-col is-3-col is-12-col-mobile is-12-col-tablet footer-links txt-white">
                    <p className="is-title">Help</p>
                    {footerMenuData?.help?.map((item, idx) =>
                        <a key={'Help-' + idx} href={item.url} className="is-row">{item.name}</a>
                    )}
                    <a href="javascript:Didomi.preferences.show()" className="is-row" title="Cookie settings">Cookie settings</a>
                </div>
            </div>
        </div>
    );
};

export default withAppState(MenuFooterLinks, {
    mobXProps: ({ activeStep, restaurant, restaurantUrl }) => ({
        activeStep,
        restaurant,
        restaurantUrl
    }),
});